import styled from '@emotion/styled';
import { StyledProps } from './NavContainer.types';
import { css } from '@styled-system/css';
import { Container } from '../../../atoms';

export default styled(Container)<StyledProps, any>`
  ${css({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    py: 0,
    px: 8,
  })}
`;
